export const BATCH_OPS_ROLES = ['batch_supervisor', 'batch_admin'];

export const BATCH_OPS_QUEUE_ROLE = 'batch_admin';

export function isBatchOpsRole(role) {
  return role === 'batch_supervisor' || role === 'batch_admin';
}
